import React, { useEffect, useState } from 'react';
import { Modal } from '@mui/material';
import { DateRangePicker } from 'react-date-range';
import moment from 'moment';
import { X } from 'phosphor-react';
import { DillButton } from '../Dill';
import { useWindowActualWidth } from '../../../utils/domTools';

function AppDateRangePickerModal({
  open,
  handleClose,
  onSelectDateRange,
  selectedDateRange,
}: {
  open: boolean;
  handleClose: () => void;
  onSelectDateRange: (range: { startDate?: Date; endDate?: Date }) => void;
  selectedDateRange: { startDate?: Date; endDate?: Date };
}) {
  const deviceWidth = useWindowActualWidth();
  const smallDeviceWidth = 800;
  const [dateRange, setDateRange] = useState<
    {
      startDate?: Date;
      endDate?: Date;
      key?: string;
    }[]
  >([
    {
      startDate: new Date(),
      endDate: moment().subtract(3, 'months').toDate(),
      key: 'selection',
    },
  ]);
  useEffect(() => {
    if (selectedDateRange) {
      setDateRange([
        {
          startDate: selectedDateRange.startDate,
          endDate: selectedDateRange.endDate,
          key: 'selection',
        },
      ]);
    }

    return () => {};
  }, [selectedDateRange]);

  const handleSelectDateRange = () => {
    onSelectDateRange({ startDate: dateRange[0]?.startDate, endDate: dateRange[0]?.endDate });
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex min-h-80 w-[95vw] md:w-fit absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white  flex-col rounded-lg px-4 ">
        <div className="w-full h-full relative pt-8">
          <X className="absolute top-2 right-1 cursor-pointer" size={20} onClick={handleClose} />
          <div className="overflow-y-scroll">
            <DateRangePicker
              onChange={(item) => setDateRange([item.selection])}
              moveRangeOnFirstSelection={true}
              months={2}
              fixedHeight={deviceWidth <= smallDeviceWidth ? true : true}
              ranges={dateRange}
              direction="horizontal"
            />
          </div>
          <div className="flex justify-end gap-2 mx-3 mb-2">
            <DillButton label="Close" variant="secondary" onClick={handleClose} />
            <DillButton label="Done" variant="primary" onClick={handleSelectDateRange} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AppDateRangePickerModal;
